import { getRequest, replaceInUrl, postRequest, putRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const getIdentificationTypes = () =>
  getRequest(
    apiEndpoints.identificationVerification.getIdentificationTypesSource,
  );

export const getAccountFundingDetails = ({ applicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.identificationVerification.identifcationInfo, {
      applicationUid,
    }),
  );

export const createIdentificationInfoRequest = ({ applicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.identificationVerification.identifcationInfo, {
      applicationUid,
    }),
    data,
  );

export const updateIdentificationInfoRequest = ({ applicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.identificationVerification.identifcationInfo, {
      applicationUid,
    }),
    data,
  );
